import { supabase } from '@cleanpro/common-ui';
import { Property, PropertyRow } from './types';

export const transformPropertyRow = (row: PropertyRow): Property => ({
    id: row.id,
    name: row.name,
    customerId: row.customer_id,
    propertyType: row.property_type,
    addressLine1: row.address_line_1,
    addressLine2: row.address_line_2,
    city: row.city,
    state: row.state,
    postalCode: row.postal_code,
    squareFootage: row.square_footage,
    bedrooms: row.bedrooms,
    bathrooms: row.bathrooms,
    floors: row.floors,
    accessInstructions: row.access_instructions,
    specialInstructions: row.special_instructions,
    hasPets: row.has_pets,
    petDetails: row.pet_details,
    preferredCleaningDay: row.preferred_cleaning_day,
    requestedTimeSlot: row.requested_time_slot,
    isActive: row.is_active,
    createdAt: row.created_at,
    updatedAt: row.updated_at,
});

export const fetchAllProperties = async (): Promise<Property[]> => {
    const { data, error } = await supabase.from('properties').select('*');
    if (error) {
        console.error('Error fetching properties:', error);
        throw error;
    }
    return (data as PropertyRow[]).map(transformPropertyRow);
};
